import classNames from "classnames";
import styles from "./style.module.scss";
interface SwitchInterface {
  toggle: boolean;
  handleChange: any;
  isCursor?: boolean;
}

function Switch(props: SwitchInterface) {
  const { toggle, handleChange, isCursor = true } = props;

  return (
    <label className={classNames(styles.switch)}>
      <input type="checkbox" checked={toggle} onChange={handleChange} />
      <span
        className={classNames(
          styles.slider,
          styles.round,
          "slider round",
          toggle && styles.active,
          isCursor && "cursor-pointer"
        )}
      ></span>
    </label>
  );
}

export default Switch;
